import { useQuery } from "@tanstack/react-query"

import type { OptionType } from "../schemas/column-schema"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

function getOptionTypes(): Promise<OptionType[]> {
  return api.get("/parser/list-option-types")
}

export function useOptionTypesQuery() {
  return useQuery({
    queryKey: queryKeys.parserOptionTypes(),
    queryFn: getOptionTypes,
  })
}
